const Star = ({ width = "9", height = "9", color = "#33CA7F" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ padding: "0.03rem" }}
    >
      <path
        d="M3.62124 0.586303C3.76415 0.111956 4.43581 0.111954 4.57873 0.586302L5.13781 2.44196C5.20145 2.65317 5.39597 2.79772 5.61656 2.79772H7.50152C7.9767 2.79772 8.18394 3.39823 7.8099 3.6913L6.22158 4.9358C6.05942 5.06285 5.99179 5.27636 6.05122 5.47361L6.64233 7.43558C6.78315 7.90296 6.23945 8.27446 5.85521 7.9734L4.40836 6.83975C4.22726 6.69785 3.97271 6.69785 3.7916 6.83975L2.34475 7.9734C1.96052 8.27446 1.41682 7.90297 1.55763 7.43558L2.14875 5.47361C2.20818 5.27636 2.14055 5.06285 1.97839 4.9358L0.390062 3.6913C0.0160238 3.39823 0.223262 2.79772 0.698441 2.79772H2.58341C2.80399 2.79772 2.99852 2.65317 3.06215 2.44196L3.62124 0.586303Z"
        fill={color}
      />
    </svg>
  );
};
export default Star;
